/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateDefinitionParameterDtoValueType } from './CreateDefinitionParameterDtoValueType';
import {
    CreateDefinitionParameterDtoValueTypeFromJSON,
    CreateDefinitionParameterDtoValueTypeFromJSONTyped,
    CreateDefinitionParameterDtoValueTypeToJSON,
} from './CreateDefinitionParameterDtoValueType';
import type { DiscreteNumericValueDtoEvaluationType } from './DiscreteNumericValueDtoEvaluationType';
import {
    DiscreteNumericValueDtoEvaluationTypeFromJSON,
    DiscreteNumericValueDtoEvaluationTypeFromJSONTyped,
    DiscreteNumericValueDtoEvaluationTypeToJSON,
} from './DiscreteNumericValueDtoEvaluationType';
import type { DiscreteNumericValueDtoGeometry } from './DiscreteNumericValueDtoGeometry';
import {
    DiscreteNumericValueDtoGeometryFromJSON,
    DiscreteNumericValueDtoGeometryFromJSONTyped,
    DiscreteNumericValueDtoGeometryToJSON,
} from './DiscreteNumericValueDtoGeometry';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';

/**
 * 
 * @export
 * @interface NumericValueDto
 */
export interface NumericValueDto {
    /**
     * 
     * @type {string}
     * @memberof NumericValueDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof NumericValueDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof NumericValueDto
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof NumericValueDto
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NumericValueDto
     */
    isReadonly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NumericValueDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NumericValueDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof NumericValueDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {number}
     * @memberof NumericValueDto
     */
    value?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NumericValueDto
     */
    numericId?: string;
    /**
     * 
     * @type {number}
     * @memberof NumericValueDto
     */
    defaultValue?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NumericValueDto
     */
    unitAbbreviation?: string | null;
    /**
     * 
     * @type {CreateDefinitionParameterDtoValueType}
     * @memberof NumericValueDto
     */
    valueType?: CreateDefinitionParameterDtoValueType | null;
    /**
     * 
     * @type {DiscreteNumericValueDtoEvaluationType}
     * @memberof NumericValueDto
     */
    evaluationType?: DiscreteNumericValueDtoEvaluationType | null;
    /**
     * 
     * @type {number}
     * @memberof NumericValueDto
     */
    decimalPlaces?: number | null;
    /**
     * 
     * @type {DiscreteNumericValueDtoGeometry}
     * @memberof NumericValueDto
     */
    geometry?: DiscreteNumericValueDtoGeometry | null;
    /**
     * 
     * @type {string}
     * @memberof NumericValueDto
     */
    groupName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NumericValueDto
     */
    groupHash?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NumericValueDto
     */
    max?: number | null;
    /**
     * 
     * @type {number}
     * @memberof NumericValueDto
     */
    min?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NumericValueDto
     */
    $type?: NumericValueDtoTypeEnum;
}


/**
 * @export
 */
export const NumericValueDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoNumericValueDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.NumericValueDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type NumericValueDtoTypeEnum = typeof NumericValueDtoTypeEnum[keyof typeof NumericValueDtoTypeEnum];


/**
 * Check if a given object implements the NumericValueDto interface.
 */
export function instanceOfNumericValueDto(value?: unknown): value is NumericValueDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(NumericValueDtoTypeEnum)[0];
}

export function NumericValueDtoFromJSON(json: any): NumericValueDto {
    return NumericValueDtoFromJSONTyped(json, false);
}

export function NumericValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NumericValueDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataTypeId': !exists(json, 'dataTypeId') ? undefined : json['dataTypeId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'isRequired': !exists(json, 'isRequired') ? undefined : json['isRequired'],
        'isReadonly': !exists(json, 'isReadonly') ? undefined : json['isReadonly'],
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'origin': !exists(json, 'origin') ? undefined : EntityOriginFromJSON(json['origin']),
        'value': !exists(json, 'value') ? undefined : json['value'],
        'numericId': !exists(json, 'numericId') ? undefined : json['numericId'],
        'defaultValue': !exists(json, 'defaultValue') ? undefined : json['defaultValue'],
        'unitAbbreviation': !exists(json, 'unitAbbreviation') ? undefined : json['unitAbbreviation'],
        'valueType': !exists(json, 'valueType') ? undefined : CreateDefinitionParameterDtoValueTypeFromJSON(json['valueType']),
        'evaluationType': !exists(json, 'evaluationType') ? undefined : DiscreteNumericValueDtoEvaluationTypeFromJSON(json['evaluationType']),
        'decimalPlaces': !exists(json, 'decimalPlaces') ? undefined : json['decimalPlaces'],
        'geometry': !exists(json, 'geometry') ? undefined : DiscreteNumericValueDtoGeometryFromJSON(json['geometry']),
        'groupName': !exists(json, 'groupName') ? undefined : json['groupName'],
        'groupHash': !exists(json, 'groupHash') ? undefined : json['groupHash'],
        'max': !exists(json, 'max') ? undefined : json['max'],
        'min': !exists(json, 'min') ? undefined : json['min'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function NumericValueDtoToJSON(value?: NumericValueDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'dataTypeId': value.dataTypeId,
        'name': value.name,
        'isRequired': value.isRequired,
        'isReadonly': value.isReadonly,
        'isEnabled': value.isEnabled,
        'iuid': value.iuid,
        'origin': EntityOriginToJSON(value.origin),
        'value': value.value,
        'numericId': value.numericId,
        'defaultValue': value.defaultValue,
        'unitAbbreviation': value.unitAbbreviation,
        'valueType': CreateDefinitionParameterDtoValueTypeToJSON(value.valueType),
        'evaluationType': DiscreteNumericValueDtoEvaluationTypeToJSON(value.evaluationType),
        'decimalPlaces': value.decimalPlaces,
        'geometry': DiscreteNumericValueDtoGeometryToJSON(value.geometry),
        'groupName': value.groupName,
        'groupHash': value.groupHash,
        'max': value.max,
        'min': value.min,
        '$type': value.$type,
    });
}

